<template>
	<div class="main">
		<div id="header" class="hero-bb1">
          	<v-layout py-3 column bottom-gradient fill-height class="lightbox white--text">
            	<v-spacer></v-spacer>
                <v-flex shrink>
                    <v-container class="py-0">
                      	<v-form  @submit="searchForm" ref="homeSearch">
                      	  	<v-layout row wrap>
		                        <v-flex xs12 sm7 md7 lg6>
		                        	<div class="font-weight-bold mb-3 hero-text-shadow" :class="$vuetify.breakpoint.smAndDown == true ? 'headline' : 'display-2'">
		                        		Explore our off-campus Hostel Listing<br>
		                        		<div :class="$vuetify.breakpoint.smAndDown == true ? 'subheading' : 'headline'" class="mt-2 text-truncate" style="font-style: italic"><span class="yellow--text">Redefining</span> your student experience...</div>
		                        	</div>
		                            <v-layout>
		                              	<v-flex grow>
			                                <v-autocomplete 
                                            	:items="searchPlaces"
			                                	:rules="$store.state.inputRules"
			                                	menu-props="offsetY"
			                                    solo
			                                    height="55"
			                                    flat
			                                    v-model.lazy="search"
			                                    label="Search for lodges by Location..."
			                                    class="bra-0"
			                                    ></v-autocomplete >
				                        </v-flex>
				                        <v-flex shrink>
				                                <v-btn type="submit" depressed class="ma-0 bra-0" style="height: 55px;min-width: 55px;" dark color="primary"><v-icon size="30">mdi-magnify</v-icon></v-btn>
				                        </v-flex>
		                            </v-layout>
		                            <div style="font-weight: 300;" class="hero-text-shadow" :class="$vuetify.breakpoint.smAndDown == true ? 'subheading' : 'title'">
		                            	Find off-campus hostels around Federal University of Technology Owerri...
		                        	</div>
		                        </v-flex>
		                        <v-flex xs12 sm5 md5 lg6></v-flex>
	                    	</v-layout>
                      	</v-form>
                    </v-container>
                </v-flex>
            	<v-spacer></v-spacer>
        	</v-layout>
        </div>

        <v-container class="my-2">
        	<h4 class="font-weight-medium text-xs-center mb-4" :class="$vuetify.breakpoint.smAndDown == true ? 'title' : 'headline'"><v-icon class="mr-1">mdi-creation</v-icon> Make well informed decisions before you move in...</span></h4>
        	<v-divider class="mb-2 lighter" />
          	<v-tabs v-model="tab" class="mb-3">
                <v-tab v-for="(place, i) in listings" :key="place.location">{{place.location}}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <template v-for="(list, j) in listings">
                	<v-tab-item :key="j">
                		<Loader v-if="list.lodges !== null && list.lodges.length === 0"  />
                		<Empty description="Its empty here! No lodge found in this Place." v-else-if="list.lodges === null"  />
	                    <v-layout v-else row wrap>
		                  	<template v-for="(lodge, k) in list.lodges">
			                    <v-flex :key="k" xs12 sm6 md4>
				                    <LodgeCard v-show="k < 3 || !$vuetify.breakpoint.mdAndUp" :item="lodge"/>
			                    </v-flex>
		                  	</template>

	                    </v-layout>
	                </v-tab-item>
                </template>
            </v-tabs-items>
            <div class="text-xs-center mt-3">
	          	<v-btn route to="/lodges" color="primary">View All Lodges...</v-btn>
	        </div>
        </v-container>

		<div class="features relative">
			<div class="overlay"></div>
	        <v-container class="py-5 relative">
	          <v-layout row wrap>
	            <v-flex xs12 lg12>
	              <div class="px-3">
	              	<h4 class="font-weight-bold display-1 text-xs-left mb-4 white--text text-xs-center">Why LOJ?</h4>
	              	<v-layout row wrap>
		              	<v-flex xs6 md4 class="px-2 text-md-center" :class="$vuetify.breakpoint.smAndDown == true ? '' : 'px-3'" v-for="(feature, index) in features" :key="index">
		              	    <v-icon :size="$vuetify.breakpoint.xsOnly == true ? '70' : '80'" color="white" style="display: block">{{feature.icon}}</v-icon>
		              	    <h5 :class="$vuetify.breakpoint.xsOnly == true ? 'body-2' : 'subheading'" class="why-title mt-3 mb-2 white--text">{{feature.title}}</h5>
		              	    <p class="white--text body-1">{{feature.content}}</p>
		              	</v-flex>
	              	</v-layout>
	              </div>
	            </v-flex>
	          </v-layout>
	        </v-container>
	    </div>

	    <div class="solution">
	        <v-container class="py-5">
	            <h4 class="font-weight-medium text-xs-center text-truncate mb-4" :class="$vuetify.breakpoint.smAndDown == true ? 'headline' : 'display-1'">One stop solution for...</h4>
	          <v-layout row wrap>
	            <v-flex xs12 sm4 class="mb-3" v-for="(solution, index) in solutions" :key="index">
		            <div v-ripple @click="solution.action" class="text-xs-center pointer">
		              	<v-avatar
		              	  size="100"
		              	  class="mx-auto"
		              	>
		              	  <img :src="solution.icon">
		              	</v-avatar>
		              	<h5 class="title mt-2" v-html="solution.text"></h5>
		            </div>
	            </v-flex>
	          </v-layout>
	          <div class="text-xs-center mt-4">
	          	<v-btn @click="$store.state.aboutDialog = true" color="primary">Learn more...</v-btn>
	          </div>
	        </v-container>
	    </div>

	</div>
</template>

<script>
import { Auth } from '@/firebase/auth';
import { DB } from '@/firebase/db';
import LodgeCard from '../components/LodgeCard.vue'
import Loader from '../components/Loader.vue'
import Empty from '../components/VEmpty.vue'
export default {
	components: {
		LodgeCard,
		Empty,
		Loader
	},
    data() {
        return {
        	tab: null,
        	search: null,
        	searchPlaces: ['Umuchima', 'Ihiagwa', 'Eziobodo'],
        	features: [
        			{icon: "mdi-account-star-outline", title: "Personalized Services", content: "No ifs, no buts, just your own personal student support specialist available 24/7. Want to chat? Get in touch anytime, day or night"},
        			{icon: "mdi-truck-fast", title: "Free access to well documented listings", content: "Students who decide patronize us get free access to well documented listings."},
        			{icon: "mdi-podium", title: "Detailed & Comprehensive Listing", content: "Every lodge on our platform has been carefully visited and inspected, and we give you access to our results so you can make a well informed decision."},
        			{icon: "mdi-shield-star-outline", title: "Instant Booking", content: "We provide an easy way to instantly book any of your preferred lodges on our platform. Simply get in touch to begin the process."},
        			{icon: "mdi-creation", title: "Stress and hassle free", content: "Gone are the days of trekking around under the hot FUTO sun or asking about just to get a lodge. We've done all that for you. Sit back, relax and search for that lodge on loj.com.ng"},
        			{icon: "mdi-bell-ring-outline", title: "Real Time Notification", content: "We give you real time notifications on the lodges you’ve visited or favorited to update you on the change on the vacancy number and student views."},
        	],
        	listings: [
        		{
        			location: "Umuchima",
        			lodges: []
        		},
        		{
        			location: "Ihiagwa",
        			lodges: []
        		},
        		{
        			location: "Eziobodo",
        			lodges: []
        		}
        	],
        	solutions: [
        		{icon: '/assets/keyIcon1.svg', text: 'Free off-campus hostel search', action: () =>{this.$router.push('/lodges')}},
        		{icon: '/assets/keyIcon4.svg', text: 'Well furnished hostel rooms <span class="beta" style="bottom:0px">Beta</span>', action: () =>{
        			this.$store.state.howItWorks = true
        		}},
        		{icon: '/assets/keyIcon3.svg', text: 'Electricity distribution to hostels rooms <span class="beta" style="bottom:0px">Beta</span>', action: () =>{
        			this.$store.state.howItWorks = true
        		}},
        	]
        };
    },
    created() {
    	let umuchima = DB.collection("lodges")
         
        umuchima.where("active", "==", true).where("location", "==", "Umuchima").orderBy("createdOn", "desc")
        .limit(4).get()
        .then((querySnapshot) => {
            this.listings[0].lodges = []
            if (querySnapshot.empty) {
                this.listings[0].lodges = null
            } else {
                let document
                querySnapshot.forEach((doc) => {
                    document = {
                        id: doc.id,
                        data: doc.data()
                    }
                    this.listings[0].lodges.push(document)
                });
            }
        })
        .catch((error) => {
            this.listings[0].lodges = null
            console.log("Error getting documents: ", error);
        });
    },
    watch: {
    	tab(arg) {
    		if (arg == 1) {
    			if (this.listings[arg].lodges.length < 1) {
    				let ihiagwa = DB.collection("lodges")
         
			        ihiagwa.where("active", "==", true).where("location", "==", "Ihiagwa").orderBy("createdOn", "desc")
			        .limit(4).get()
			        .then((querySnapshot) => {
			            this.listings[arg].lodges = []
			            if (querySnapshot.empty) {
			                this.listings[arg].lodges = null
			            } else {
			                let document
			                querySnapshot.forEach((doc) => {
			                    document = {
			                        id: doc.id,
			                        data: doc.data()
			                    }
			                    this.listings[arg].lodges.push(document)
			                });
			            }
			        })
			        .catch((error) => {
			            this.listings[arg].lodges = null
			            console.log("Error getting documents: ", error);
			        });
    			}
    		}

    		if (arg == 2) {
    			if (this.listings[arg].lodges.length < 1) {
    				let eziobodo = DB.collection("lodges")
         
			        eziobodo.where("active", "==", true).where("location", "==", "Eziobodo").orderBy("createdOn", "desc")
			        .limit(4).get()
			        .then((querySnapshot) => {
			            this.listings[arg].lodges = []
			            if (querySnapshot.empty) {
			                this.listings[arg].lodges = null
			            } else {
			                let document
			                querySnapshot.forEach((doc) => {
			                    document = {
			                        id: doc.id,
			                        data: doc.data()
			                    }
			                    this.listings[arg].lodges.push(document)
			                });
			            }
			        })
			        .catch((error) => {
			            this.listings[arg].lodges = null
			            console.log("Error getting documents: ", error);
			        });
    			}
    		}
    	}
    },
    methods: {
        searchForm(e) {
            e.preventDefault()
            if(this.$refs.homeSearch.validate()){
                this.$router.push({ path: 'lodges', query: { search: this.search} })
            } else {
                this.$store.dispatch('setSnackText', "Search field is required!")
            }
        },
    }
};
</script>

<style scoped>
#header {
	background-image: url('/img/hero-bg3.jpg');
	background-position: right top;
	background-size: cover;
	height: 400px;
	background-repeat: no-repeat;
}
.why-title {
	border-bottom: 2px solid #32cd31cf;
	display: inline-block;
}
.features {
	border-top: 1px solid #f9ffff;
	border-bottom: 1px solid #f9ffff;
	background: url('/img/hero-bg12.jpg');
	background-position: left top;
	background-size: cover;
	background-repeat: no-repeat;
}
.solution {
	background: #f5f5f5;
}
.icon {
	color: #32cd31cf
}
.bottom-gradient {
   background-image: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, transparent 70%);
}
.overlay {
	position: absolute;
	height: 100%;
	width: 100%;
	background: rgba(0,0,0,0.5);
}
@media only screen and (max-width: 959px) {
    #header {
        height: 300px;
    }
    .features {
		background: url('/img/hero-bg2.jpg');
		background-position: center top;
		background-repeat: no-repeat;
		background-position: center top;
		background-size: cover;
	}
	.bottom-gradient {
	   background-image: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.2) 100%);
	}
}
</style>